import { render, staticRenderFns } from "./coffee-rating-card.vue?vue&type=template&id=19b3d4d8&scoped=true&"
import script from "./coffee-rating-card.vue?vue&type=script&lang=js&"
export * from "./coffee-rating-card.vue?vue&type=script&lang=js&"
import style0 from "./coffee-rating-card.vue?vue&type=style&index=0&id=19b3d4d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b3d4d8",
  null
  
)

export default component.exports